function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".seed-list-white_svg__cls-1{fill:#fff}.seed-list-white_svg__cls-2,.seed-list-white_svg__cls-3,.seed-list-white_svg__cls-5{fill:none}.seed-list-white_svg__cls-2,.seed-list-white_svg__cls-3{stroke:#fff}.seed-list-white_svg__cls-3{stroke-dasharray:1 1}.seed-list-white_svg__cls-4{stroke:none}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "seed-list-white_svg__Component_113_173"
}, /*#__PURE__*/React.createElement("g", {
  id: "seed-list-white_svg__Group_21782",
  transform: "rotate(-90 9.5 9.5)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "seed-list-white_svg__Ellipse_725",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list-white_svg__cls-1",
  transform: "rotate(180 6 2.5)"
}), /*#__PURE__*/React.createElement("g", {
  id: "seed-list-white_svg__Ellipse_728",
  className: "seed-list-white_svg__cls-2",
  transform: "rotate(180 2.5 2.5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list-white_svg__cls-4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2,
  className: "seed-list-white_svg__cls-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "seed-list-white_svg__Ellipse_789",
  className: "seed-list-white_svg__cls-2",
  transform: "rotate(180 2.5 9.059)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list-white_svg__cls-4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2,
  className: "seed-list-white_svg__cls-5"
})), /*#__PURE__*/React.createElement("circle", {
  id: "seed-list-white_svg__Ellipse_788",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list-white_svg__cls-1",
  transform: "rotate(180 6 9.059)"
}), /*#__PURE__*/React.createElement("path", {
  id: "seed-list-white_svg__Line_546",
  d: "M5 0H0",
  className: "seed-list-white_svg__cls-3",
  transform: "rotate(180 5.25 1.25)"
}), /*#__PURE__*/React.createElement("g", {
  id: "seed-list-white_svg__Group_22032",
  transform: "translate(7 6.479)"
}, /*#__PURE__*/React.createElement("g", {
  id: "seed-list-white_svg__Ellipse_787",
  className: "seed-list-white_svg__cls-2",
  transform: "translate(7)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list-white_svg__cls-4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2,
  className: "seed-list-white_svg__cls-5"
})), /*#__PURE__*/React.createElement("circle", {
  id: "seed-list-white_svg__Ellipse_729",
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  className: "seed-list-white_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  id: "seed-list-white_svg__Line_547",
  d: "M0 0h6",
  className: "seed-list-white_svg__cls-3",
  transform: "rotate(180 3.25 1.25)"
})), /*#__PURE__*/React.createElement("path", {
  id: "seed-list-white_svg__Line_548",
  d: "M6 0H0",
  className: "seed-list-white_svg__cls-3",
  transform: "rotate(180 5.75 7.809)"
})));
function SvgSeedListWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.118,
    height: 19,
    viewBox: "0 0 18.118 19"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='18.118' height='19' viewBox='0 0 18.118 19'%3e %3cdefs%3e %3cstyle%3e .cls-1%7bfill:%23fff%7d.cls-2,.cls-3,.cls-5%7bfill:none%7d.cls-2,.cls-3%7bstroke:%23fff%7d.cls-3%7bstroke-dasharray:1 1%7d.cls-4%7bstroke:none%7d %3c/style%3e %3c/defs%3e %3cg id='Component_113_173'%3e %3cg id='Group_21782' transform='rotate(-90 9.5 9.5)'%3e %3ccircle id='Ellipse_725' cx='2.5' cy='2.5' r='2.5' class='cls-1' transform='rotate(180 6 2.5)'/%3e %3cg id='Ellipse_728' class='cls-2' transform='rotate(180 2.5 2.5)'%3e %3ccircle cx='2.5' cy='2.5' r='2.5' class='cls-4'/%3e %3ccircle cx='2.5' cy='2.5' r='2' class='cls-5'/%3e %3c/g%3e %3cg id='Ellipse_789' class='cls-2' transform='rotate(180 2.5 9.059)'%3e %3ccircle cx='2.5' cy='2.5' r='2.5' class='cls-4'/%3e %3ccircle cx='2.5' cy='2.5' r='2' class='cls-5'/%3e %3c/g%3e %3ccircle id='Ellipse_788' cx='2.5' cy='2.5' r='2.5' class='cls-1' transform='rotate(180 6 9.059)'/%3e %3cpath id='Line_546' d='M5 0L0 0' class='cls-3' transform='rotate(180 5.25 1.25)'/%3e %3cg id='Group_22032' transform='translate(7 6.479)'%3e %3cg id='Ellipse_787' class='cls-2' transform='translate(7)'%3e %3ccircle cx='2.5' cy='2.5' r='2.5' class='cls-4'/%3e %3ccircle cx='2.5' cy='2.5' r='2' class='cls-5'/%3e %3c/g%3e %3ccircle id='Ellipse_729' cx='2.5' cy='2.5' r='2.5' class='cls-1'/%3e %3cpath id='Line_547' d='M0 0L6 0' class='cls-3' transform='rotate(180 3.25 1.25)'/%3e %3c/g%3e %3cpath id='Line_548' d='M6 0L0 0' class='cls-3' transform='rotate(180 5.75 7.809)'/%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgSeedListWhite as ReactComponent };